export default {
      id: "app-google-usage",
      viewBox: "0 0 4096 1214",
      url: "/assets/svg/" + "sprite.svg#app-google-usage",
      toString: function () {
        return this.url;
      }
    }